import React from 'react';

import { Tooltip } from '@cowbell/ui';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import classes from './OrgFieldHint.module.css';

interface OrgFieldHintProps {
  readonly label: string;
  readonly hint: string;
}

/**
 * A field label with the design's tooltip launcher beside it.
 *
 * <p>Sized in `em` against the label, because a launcher left at its own size
 * makes its label taller than the ones beside it and drops that field's
 * control a pixel below its row.
 */
export const OrgFieldHint = ({ label, hint }: OrgFieldHintProps) => {
  return (
    <>
      {label}
      <Tooltip label={hint} multiline w={220} withArrow position="top">
        <span className={classes.launcher} aria-label={hint} role="img">
          <InfoOutlinedIcon fontSize="inherit" />
        </span>
      </Tooltip>
    </>
  );
};

export default OrgFieldHint;
